 import '../../commom/Challenger.js';

/**
 *处理明细的编码
 *
 * @export
 * @class DetailCodeProcessor
 * @auther 马坚
 */
export class DetailCodeProcessor
{
    static execute(dto)
    {
        if(dto && dto.RetailDetails 
            && dto.RetailDetails instanceof Array && dto.RetailDetails.length>0)
        {
            for(var i=0;i<dto.RetailDetails.length;i++)
            {
                dto.RetailDetails[i].Code = i.toString().PadLeft(4, '0');
            }
        }
    }
}